import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface MessageBoxData {
    title: string;
    message: string;
    actions: string[];
}

@Component({
    selector: 'message-box',
    templateUrl: './messagebox.component.html',
})
export class MessageBoxComponent {
    constructor(
        public dialogRef: MatDialogRef<MessageBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MessageBoxData
    ) {}

    onAction(action: string): void {
        this.dialogRef.close(action);
    }
}
